import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/style/common.scss'

// FlappyPIX fidelity 样式与 finally 原有页面共存；这些文件来自已验证的 Vue2 源项目。
import './styles/fidelity/00_foundation_guest_shell.css'
import './styles/fidelity/10_gameplay_shared.css'
import './styles/fidelity/20_authenticated_home.css'
import './styles/fidelity/21_authenticated_commercial_polish.css'
import './styles/fidelity/22_input_runtime.css'
import './styles/fidelity/30_paid_result.css'
import './styles/fidelity/40_cashout_gameplay.css'
import './styles/fidelity/50_cashout_entry.css'
import './styles/fidelity/99_vue2_fragment_compat.css'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import { formatNumber } from "@/utils/common";
Vue.prototype.$FormatNumber = formatNumber;

Vue.config.productionTip = false
import { GetUserInfo } from "@/api/Perfil";

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    if (location.search) this.$store.commit('SETSEARCHPARAMS', location.search);
    this.setFontSize();
    setInterval(() => {
      if (this.$store.state.userInfo.token && this.$route.path !== '/Scratch' && this.$route.path !== '/withdraw/normal' && this.$route.path !== '/iof' && this.$route.path !== '/TAXAIOF' && this.$route.path !== '/qrcode') {
        GetUserInfo().then(res => {
          this.$store.commit('SETCASH', res);
          this.$store.commit('SETPAYINCASHLIST', res.payInCashList);
          this.$store.commit('SETSPININFO', res);
        });
      }
    }, 2000);
  },
  mounted() {
    window.addEventListener('resize', this.setFontSize);
  },
  methods: {
    // 计算根元素 FontSize，设置 rem
    setFontSize () {
      document.documentElement.style.fontSize = `${document.documentElement.clientWidth / 24}px`;
    }
  },
}).$mount('#app')
